import React from 'react';
import { SvgIcon } from "@material-ui/core";

export const StatusIcon = (props: any) => {
  return (
    <SvgIcon {...props}  width="15" height="15" viewBox="0 0 15 15">
      <path fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 7.067h-2.6l-1.95 6.066L5.55 1 3.6 7.067H1"/>
    </SvgIcon>
  );
};